<template>
  <div class="container">
    <Header></Header>
    <HeaderMobile></HeaderMobile>
    <div class="register-container">
      <div class="register-left">
        <AuthHead head="Register with"></AuthHead>
        <ThirdParty
          type="register"
          optionText="Or register using email:"
        ></ThirdParty>
        <div class="auth-input-section">
          <InputWidget
            @changed="handleEmailChanged"
            :isPassword="false"
            placeholder="Email"
          ></InputWidget>
          <InputWidget
            @changed="handlePasswordChanged"
            :isPassword="true"
            placeholder="Password"
          ></InputWidget>
          <Checkbox
            text="I accept all the terms and conditions"
            id="terms"
            @checkChanged="handleCheckChanged"
          ></Checkbox>
          <ButtonFilled
            @onButtonClicked="register"
            :text="registerText"
          ></ButtonFilled>
          <div class="error-message" v-html="errorMessage"></div>
        </div>
      </div>
      <div class="register-right">
        <div class="register-right-overlay"></div>
        <AuthCardTwo
          head="Been there, done that?"
          subhead="Right this way cheif."
          buttonText="Login to my account"
          @clicked="handleCreateAccount"
        ></AuthCardTwo>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable -->

<script>
import AuthHead from "../../../components/auth/AuthHead";
import AuthCardTwo from "../../../components/auth/AuthCardTwo";
import InputWidget from "../../../components/common/InputWidget";
import ButtonFilled from "../../../components/common/ButtonFilled";
import ThirdParty from "../../../components/auth/ThirdParty";
import Header from "../../../components/landing/Header";
import HeaderMobile from "../../../components/landing/HeaderMobile";
import Checkbox from "../../../components/common/Checkbox";
import { handleRegister } from "../../../service/user";

export default {
  components: {
    AuthHead,
    AuthCardTwo,
    InputWidget,
    ButtonFilled,
    ThirdParty,
    Header,
    HeaderMobile,
    Checkbox,
  },

  data() {
    return {
      headline: "",
      email: "",
      password: "",
      registerText: "Create Account",
      errorMessage: "",
      token: "",
      rcode: "",
      isChecked: false,
    };
  },

  methods: {
    handleCheckChanged(checked) {
      console.log(checked);
      this.isChecked = checked;
    },
    validateEmail(emailField) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (reg.test(emailField) == false) {
        return false;
      }
      return true;
    },
    validatePassword(password) {
      var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    handleEmailChanged(email) {
      this.email = email;
    },
    handlePasswordChanged(password) {
      this.password = password;
    },
    async register() {
      this.errorMessage = "";
      if(!this.isChecked){
        this.errorMessage = "Please accept the terms and conditions";
        return;
      }
      if (
        this.validateEmail(this.email) &&
        this.validatePassword(this.password)
      ) {
        this.registerText = "Wait...";
        try {
          const res = await handleRegister(
            this.email,
            this.password,
            0,
            this.token,
            this.rcode
          );
          if (res.status == 201 || res.status == 210 || res.status == 200) {
            this.$router.push({ path: "user/dashboard" });
          } else {
            this.registerText = "Create Account";
            this.errorMessage = res;
          }
        } catch (e) {
          // console.log(e);
          this.registerText = "Create Account";
          this.errorMessage = e.message;
        }
      } else {
        if (!this.validateEmail(this.email)) {
          this.errorMessage += "Invalid Email" + "<br/>";
        }
        if (!this.validatePassword(this.password)) {
          this.errorMessage +=
            "Password must be of minimum eight characters." + "<br/>";
        }
      }
    },
    handleCreateAccount() {
      this.$router.push({ name: "login" });
    },
  },
  async mounted() {
    window.scroll(0, 0);
    try {
      this.token = window.location.href.split("?token=")[1];
    } catch (e) {}
    try{
      this.rcode = window.location.href.split("?rcode=")[1];
    }catch(e){

    }
  },
};
</script>

<style scoped>
.container {
  margin: auto;
  min-height: 100%;
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  transition: 0.5s;
  height: 1000px;
  margin: auto;
  margin-top: 14px;
  margin-bottom: 14px;
}

.button-filled {
  margin-top: 16px !important;
}

.register-container {
  background-color: #1a1c1f;
  border-radius: 7px;

  width: 976px;
  box-shadow: 2px 2px 5px #0000002a;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 180% 170% at top,
    #26292e 0.4%,
    #1a1c1f 100%
  );
  transition: 0.3s;
}

.register-left {
  flex: 0.6;
  max-width: 60%;
  height: 568px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s;
}

.register-right {
  position: relative;
  flex: 0.4;
  max-width: 40%;
  height: 568px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient(
    ellipse 300% 150% at right bottom,
    #26292e 0.04%,
    #1a1c1f 100%
  );
  border-bottom-right-radius: 25px;
  border-top-right-radius: 25px;
  transition: 0.3s;
}

.register-right-overlay {
  position: absolute;
  background: url("../../../assets/img/dom-labs.svg");
  background-repeat: no-repeat;
  background-size: auto;
  height: 100%;
  width: 100%;
}

.auth-input-section {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 70%;
}

.input-widget {
  margin-top: 0px !important;
  width: 80% !important;
}

@media only screen and (max-width: 786px) {
  #headerWeb {
    display: none !important;
  }
  #landingHeaderMobile {
    display: block !important;
  }
}

@media only screen and (max-width: 750px) {
  .register-left,
  .register-right {
    flex: 50% !important;
    max-width: 50% !important;
    width: 50%;
  }

  input {
    width: 230px;
  }
  .auth-input-section {
    width: 90% !important;
  }
}

@media only screen and (max-width: 610px) {
  .container {
    height: 100% !important;
  }
  .register-left,
  .register-right {
    flex: 100% !important;
    max-width: 100% !important;
    width: 100%;
  }

  .register-right {
    border-radius: 0px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  .register-left {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  input {
    width: 230px;
  }

  .register-container {
    flex-wrap: wrap !important;
    margin-top: 100px !important;
  }
}
</style>
